import io from "socket.io-client";

const ENDPOINT =
  process.env.NODE_ENV === "development"
    ? "http://localhost:5000/"
    : window.location.origin;

export const socket = io(ENDPOINT);
